import {List, ListItem} from '@logistics-frontend/blocks'
import {get} from '@logistics-frontend/utils'
import React from 'react'

import {AdvertModalProps} from '../types'
import * as classes from './AdvertInfoContent.classes'

type Props = {
  contentItems: AdvertModalProps['content']
}

export const AdvertInfoContent: React.FC<Props> = ({contentItems}) => (
  <List
    className={classes.root}
    getId={get('title')}
    items={contentItems}
    renderItem={({title, subtitle}) => (
      <ListItem flexDirection="column" justifyContent="center" size="l">
        <List.Label>{title}</List.Label>
        <List.Description color="minor">{subtitle}</List.Description>
      </ListItem>
    )}
  />
)
